import debounce from "lodash/debounce";

jQuery(document).ready(function ($) {
  // escape hatch
  if (!$(".event-menu").length) return;

  // event priority navigation
  const $vlinks = $("#menu-main-menu"),
    $hlinks = $(".event-menu-overflow-links"),
    $ofitem = $(".event-menu-overflow"),
    $currentRoom = $(".event-menu .room-current .dropdown__trigger");

  var priorityInit = false,
    numOfItems = 0,
    totalSpace = 0,
    breakWidths = [];

  let availableSpace, numOfVisibleItems, requiredSpace;

  // initialize priority nav once
  function initializePriority() {
    // initial state
    numOfItems = 0;
    totalSpace = 0;
    breakWidths = [];

    $vlinks.children(":not(.event-menu-overflow)").outerWidth(function (i, w) {
      totalSpace += w;
      numOfItems += 1;
      breakWidths.push(totalSpace);
    });

    priorityInit = true;
  }

  // update priority nav state
  function checkPriorityNav() {
    // if mobile nav open, don't run
    if (window.innerWidth <= 960) return;

    // initialize priority if it has not been done
    if (!priorityInit) initializePriority();

    // Get instant state
    if ($hlinks.children().length) availableSpace = $vlinks.width() - 100;
    // rough width of overflow
    else availableSpace = $vlinks.width();

    numOfVisibleItems = $vlinks.children(":not(.event-menu-overflow)").length;
    requiredSpace = breakWidths[numOfVisibleItems - 1];

    // Not enough space
    if (requiredSpace > availableSpace) {
      $vlinks.children(":not(.event-menu-overflow)").last().prependTo($hlinks);
      numOfVisibleItems -= 1;
      checkPriorityNav();

      // More than enough space
    } else if (availableSpace > breakWidths[numOfVisibleItems]) {
      $hlinks.children().first().insertBefore($ofitem);
      numOfVisibleItems += 1;
    }
    // Update the button
    $ofitem.attr("count", numOfItems - numOfVisibleItems);
    if (numOfVisibleItems === numOfItems) {
      $ofitem.removeClass("is-visible");
      $vlinks
        .children(":not(.event-menu-overflow)")
        .last()
        .addClass("last-item");
    } else {
      $vlinks
        .children(":not(.event-menu-overflow)")
        .last()
        .removeClass("last-item");
      $ofitem.addClass("is-visible");
      $ofitem.addClass("last-item");
    }
  }

  // event handlers
  $(".site-logo")
    .on("load", function () {
      checkPriorityNav();
    })
    .each(function () {
      if (this.complete) $(this).load();
    });
  window.addEventListener("load", checkPriorityNav);
  window.addEventListener("resize", debounce(checkPriorityNav, 100));
  $currentRoom.on("click", function (e) {
    e.preventDefault();
  });
});
